export const vehicleMakes = [
    { code: 'AC', name: 'AC' },
    { code: 'ACADIAN', name: 'Acadian' },
    { code: 'ACURA', name: 'Acura' },
    { code: 'ALFA_ROMEO', name: 'Alfa Romeo' },
    { code: 'AM_GENERAL', name: 'AM General' },
    { code: 'ASTON_MARTIN', name: 'Aston Martin' },
    { code: 'AUDI', name: 'Audi' },
    { code: 'BENTLEY', name: 'Bentley' },
    { code: 'BMW', name: 'BMW' },
    { code: 'BUICK', name: 'Buick' },
    { code: 'CADILLAC', name: 'Cadillac' },
    { code: 'CHEVROLET', name: 'Chevrolet' },
    { code: 'CHRYSLER', name: 'Chrysler' },
    { code: 'DODGE', name: 'Dodge' },
    { code: 'FERRARI', name: 'Ferrari' },
    { code: 'FIAT', name: 'FIAT' },
    { code: 'FORD', name: 'Ford' },
    { code: 'GENESIS', name: 'Genesis' },
    { code: 'GMC', name: 'GMC' },
    { code: 'HONDA', name: 'Honda' },
    { code: 'HUMMER', name: 'HUMMER' },
    { code: 'HYUNDAI', name: 'Hyundai' },
    { code: 'INFINITI', name: 'INFINITI' },
    { code: 'ISUZU', name: 'Isuzu' },
    { code: 'JAGUAR', name: 'Jaguar' },
    { code: 'JEEP', name: 'Jeep' },
    { code: 'KIA', name: 'Kia' },
    { code: 'LAMBORGHINI', name: 'Lamborghini' },
    { code: 'LAND_ROVER', name: 'Land Rover' },
    { code: 'LEXUS', name: 'Lexus' },
    { code: 'LINCOLN', name: 'Lincoln' },
    { code: 'LOTUS', name: 'Lotus' },
    { code: 'MASERATI', name: 'Maserati' },
    { code: 'MAZDA', name: 'Mazda' },
    { code: 'MCLAREN', name: 'McLaren' },
    { code: 'MERCEDES_BENZ', name: 'Mercedes-Benz' },
    { code: 'MERCURY', name: 'Mercury' },
    { code: 'MINI', name: 'MINI' },
    { code: 'MITSUBISHI', name: 'Mitsubishi' },
    { code: 'NISSAN', name: 'Nissan' },
    { code: 'OLDSMOBILE', name: 'Oldsmobile' },
    { code: 'POLESTAR', name: 'Polestar' },
    { code: 'PONTIAC', name: 'Pontiac' },
    { code: 'PORSCHE', name: 'Porsche' },
    { code: 'RAM', name: 'RAM' },
    { code: 'ROLLS_ROYCE', name: 'Rolls-Royce' },
    { code: 'SAAB', name: 'Saab' },
    { code: 'SATURN', name: 'Saturn' },
    { code: 'SCION', name: 'Scion' },
    { code: 'SHELBY', name: 'Shelby' },
    { code: 'SMART', name: 'smart' },
    { code: 'SUBARU', name: 'Subaru' },
    { code: 'SUZUKI', name: 'Suzuki' },
    { code: 'TESLA', name: 'Tesla' },
    { code: 'TOYOTA', name: 'Toyota' },
    { code: 'VINFASTA', name: 'VinFast' },
    { code: 'VOLKSWAGEN', name: 'Volkswagen' },
    { code: 'VOLVO', name: 'Volvo' },
    { code: 'WILLYS', name: 'Willys' }
]

export const motorcycleMakes = [
    { code: 'APRILIA', name: 'Aprilia' },
    { code: 'BMW_MOTORCYCLES', name: 'BMW Motorcycles' },
    { code: 'BUELL', name: 'Buell' },
    { code: 'DUCATI', name: 'Ducati' },
    { code: 'HARLEY_DAVIDSON', name: 'Harley-Davidson' },
    { code: 'HONDA_MOTORCYCLES', name: 'Honda Motorcycles' },
    { code: 'HUSQVARNA', name: 'Husqvarna' },
    { code: 'INDIAN_MOTORCYCLE', name: 'Indian Motorcycle' },
    { code: 'KAWASAKI', name: 'Kawasaki' },
    { code: 'KTM', name: 'KTM' },
    { code: 'MOTO_GUZZI', name: 'Moto Guzzi' },
    { code: 'MV_AGUSTA', name: 'MV Agusta' },
    { code: 'PIAGGIO', name: 'Piaggio' }
]

export const boatMakes = [
    { code: 'ALBEMARLE', name: 'Albemarle' },
    { code: 'AZIMUT', name: 'Azimut' },
    { code: 'BENETEAU', name: 'Beneteau' },
    { code: 'BERTRAM', name: 'Bertram' },
    { code: 'BAYLINER', name: 'Bayliner' },
    { code: 'BOSTON_WHALER', name: 'Boston Whaler' },
    { code: 'CAMPER_AND_NICHOLSONS', name: 'Camper and Nicholsons' },
    { code: 'CARVER', name: 'Carver' },
    { code: 'CHRIS_CRAFT', name: 'Chris-Craft' },
    { code: 'CORRECT_CRAFT', name: 'Correct Craft' },
    { code: 'CRUISERS_YACHTS', name: 'Cruisers Yachts' },
    { code: 'FORMULA', name: 'Formula' },
    { code: 'FOUR_WINNS', name: 'Four Winns' },
    { code: 'GRADY_WHITE', name: 'Grady-White' },
    { code: 'HATTERAS', name: 'Hatteras' },
    { code: 'JEANNEAU', name: 'Jeanneau' },
    { code: 'LARSON', name: 'Larson' },
    { code: 'LUND', name: 'Lund' },
    { code: 'MASTERCRAFT', name: 'MasterCraft' },
    { code: 'REGAL', name: 'Regal' },
    { code: 'RINKER', name: 'Rinker' },
    { code: 'SEA_RAY', name: 'Sea Ray' },
    { code: 'TRACKER', name: 'Tracker' },
    { code: 'VIKING_YACHTS', name: 'Viking Yachts' },
    { code: 'YAMAHA_BOATS', name: 'Yamaha Boats' }
]

export const atvMakes = [
    { code: 'ARCTIC_CAT', name: 'Arctic Cat' },
    { code: 'CAN_AM', name: 'Can-Am' },
    { code: 'HONDA_ATV', name: 'Honda' },
    { code: 'KAWASAKI_ATV', name: 'Kawasaki' },
    { code: 'POLARIS', name: 'Polaris' },
    { code: 'SUZUKI_ATV', name: 'Suzuki' },
    { code: 'YAMAHA_ATV', name: 'Yamaha' }
]